import apiFetch from '../apiFetch'

export default function (token, signatureEntity) {
  return apiFetch({ endPoint: 'SignEntity', method: 'POST', body: signatureEntity, token: token })
}
